import { useEffect, useState } from "react";

const links = [
  { id: "mission", label: "Mission" },
  { id: "vision", label: "Vision" },
  { id: "purpose", label: "Purpose" },
  { id: "ripple", label: "Ripple" },
  { id: "founder", label: "Founder" },
  { id: "join", label: "Join" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 32);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[#F9F8F6]/85 backdrop-blur-md border-b border-[#2D3730]/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          onClick={(e) => handleClick(e, "top")}
          className="flex items-center gap-2 group"
        >
          <img
            src="/fabfathers-logo.png"
            alt="FabFathers"
            className="h-16 md:h-20 w-auto object-contain"
          />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              data-testid={`nav-link-${l.id}`}
              onClick={(e) => handleClick(e, l.id)}
              className="link-underline text-[13px] uppercase tracking-[0.2em] text-[#2D3730] font-medium"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#join"
          data-testid="nav-cta"
          onClick={(e) => handleClick(e, "join")}
          className="hidden md:inline-flex items-center gap-2 bg-[#2D3730] text-[#F9F8F6] px-5 py-2.5 text-[12px] uppercase tracking-[0.18em] hover:bg-[#C06E52] transition-colors duration-500"
        >
          Join the Movement
        </a>

        <a
          href="#join"
          data-testid="nav-cta-mobile"
          onClick={(e) => handleClick(e, "join")}
          className="md:hidden text-[12px] uppercase tracking-[0.18em] text-[#2D3730] border-b border-[#2D3730]"
        >
          Join
        </a>
      </div>
    </header>
  );
};
